import { ApolloClient, gql, HttpLink, InMemoryCache } from '@apollo/client';
import { Link } from '../components/Link';

const GRAPHQL_ENDPOINT = "http://localhost:8080/graphql";

const client: ApolloClient = new ApolloClient({
  link: new HttpLink({ uri: GRAPHQL_ENDPOINT }),
  cache: new InMemoryCache(),
});

export async function getLinks(): Promise<Link[]> {
  console.log("getLinks() called");
  const GET_LINKS = gql`
    query GetLinks {
      getLinks {
        url
        description
      }
    }
  `;
  const result = await client.query<{getLinks: Link[]}>({query: GET_LINKS});

  // result.data can still be undefined if operation fails
  if (!result.data) throw new Error('Query failed');

  return result.data.getLinks;
}

export async function saveLinks(links: Link[]): Promise<Link[]> {
  console.log('saveLinks() called');

  const SAVE_LINKS = gql`
    mutation SaveLinks($links: [LinkInput]!) {
      saveLinks(links: $links) {
        url
        description
      }
    }
  `;

  const result = await client.mutate<{saveLinks: Link[]}>({
    mutation: SAVE_LINKS,
    variables: { links },
  });

  // result.data can still be undefined if operation fails
  if (!result.data) throw new Error('Mutation failed');

  return result.data?.saveLinks as Link[];
}

export async function saveLink(link: Link): Promise<Link> {
  console.log('saveLink() called');

  const SAVE_LINK = gql`
    mutation SaveLink($link: LinkInput!) {
      saveLink(link: $link) {
        url
        description
      }
    }
  `;

  const result = await client.mutate<{ saveLink: Link }>({
    mutation: SAVE_LINK,
    variables: { link },
  });

  if (!result.data) throw new Error('Mutation failed');

  return result.data.saveLink;
}